import { BouncebanChip, Icon, Label } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Box, Tooltip, Typography } from '@mui/material';
import { Fragment, memo } from 'react';
import { usePlanCardContext } from '../../context';
import * as Styled from './styles';
import * as SX from './sx';
import type { PlanInclusionProps as Props } from './types';

export const PlanInclusion = memo(({ className }: Props) => {
  const { isMostPopular, config } = usePlanCardContext();
  const { featureGroups } = config;

  if (!featureGroups?.length) return null;

  const headerColor = isMostPopular ? 'common.white' : 'grey.800';
  const itemTextColor = isMostPopular ? 'common.white' : 'common.black';
  const itemIconColor = isMostPopular ? 'common.white' : 'grey.500';
  const disabledColor = isMostPopular ? 'rgba(255,255,255,0.4)' : 'grey.400';

  return (
    <Styled.Wrapper
      className={classnames('PlanInclusion', className)}
      sx={SX.root}
    >
      {featureGroups.map((group) => (
        <Box key={group.title} sx={SX.group}>
          <Box sx={SX.groupHeader(isMostPopular)}>
            <Typography variant="body4" fontWeight={700} color={headerColor}>
              {group.title}
            </Typography>
          </Box>
          <Box sx={SX.featureList}>
            {group.features.map((feature) => (
              <Fragment key={feature.id}>
                <Box sx={SX.featureRow}>
                  <Box sx={SX.featureLeft}>
                    <Tooltip
                      title={feature.description ?? ''}
                      placement="top"
                      arrow
                    >
                      <Box sx={{ display: 'flex' }}>
                        <Icon
                          name="info-circle-outline"
                          size={18}
                          color={
                            feature.disabled ? disabledColor : itemIconColor
                          }
                        />
                      </Box>
                    </Tooltip>
                    <Typography
                      variant="body4"
                      fontWeight={500}
                      color={feature.disabled ? disabledColor : itemTextColor}
                    >
                      {feature.title}
                    </Typography>
                  </Box>
                  {feature.comingSoon && (
                    <Label color="default" variant="soft" size="xxsmall">
                      Coming Soon
                    </Label>
                  )}
                </Box>
                {feature.poweredBy && (
                  <Box sx={SX.poweredByRow}>
                    <BouncebanChip />
                  </Box>
                )}
              </Fragment>
            ))}
          </Box>
        </Box>
      ))}
    </Styled.Wrapper>
  );
});

PlanInclusion.displayName = 'PlanInclusion';
